var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-overlay',{attrs:{"absolute":"","opacity":"0.8"}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$t('chargePlan.areaLockMessage'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }